import { SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { ProjectHelpers } from 'helpers/ProjectHelpers';

import { useCurrentUser } from 'hooks/use-current-user';
import { ProjectService } from 'services/ProjectService';

const useRecentProjects = (options: Pick<SWRConfiguration, 'revalidateOnMount'> = {}) => {
    const user = useCurrentUser();

    const key = user ? ProjectHelpers.swr.recentProjects() : null;

    const { data = [], isLoading } = useSWRImmutable(
        key,
        async () => {
            return ProjectService.getRecentProjects();
        },
        options,
    );

    return {
        recentProjects: data,
        isLoading,
    };
};

export { useRecentProjects };
